<template>
	<div class="single-page-wrap">
		<cube-scroll ref="scroll" class="cube-scroll">
			<div class="advwrap"></div>
			<article class="weui-article">
				<section>
					<p>您当前已绑定{{plateList.length}}个车牌</p>
				</section>
			</article>
			<div class="weui-cells" v-if="plateList.length > 0">
				<div class="weui-cell weui-cell_active weui-cell_access" v-for="item of plateList" :key="item.id">
					<div class="weui-cell__bd">{{item.plateNumber}}</div>
					<div class="weui-cell__ft weui-cell__cash" style="font-size: 0;">
						<button class="weui-btn weui-btn_mini weui-btn_default" @click="handleUntie(item.userId, item.plateNumber)">解绑</button>
					</div>
				</div>
			</div>
			<no-data v-else msg="暂无"></no-data>
		</cube-scroll>
		<div class="weui-btn-area">
			<button class="weui-btn weui-btn_primary" @click="handleBindPlate">绑定车牌</button>
		</div>
	</div>
</template>

<script>
	import { relievePlate, plateList,getXcxParkinglotInfo } from "../../../api/coupon/xcxbindPlate";
	import { mapGetters, mapMutations } from 'vuex'

    export default {
        name: "plateInfo",
		data () {
            return {
                plateList: [],
                scrollOptions: {
                    click: true,
                    bounce: false
                },
			}
		},
		computed: {
			...mapGetters(['userOpenid','abParkId'])
		},
		activated () {
            this.getPlateList();
		},
		mounted () {
			this.getAdInfo()
		},
		methods: {
			...mapMutations({
                setAbParkId: "SET_ABPARKID",
                setOpenAD: "SET_OPENAD"
			}),
            //获取广告信息
            getAdInfo() {
				let params = {
					parkinglotId:13,
					appId:20000,
				}
                getXcxParkinglotInfo(params).then(res => {
					console.log(res,'123456789');
                    this.parkName = res.data.data.parkName;
                    this.setOpenAD(res.data.data.isOpenAdvertising);
                    let data = {
                        address: res.data.data.address,
                        parkName: res.data.data.parkName
                    };
                    if (res.data.data.isOpenAdvertising == 1) {
						console.log(data,'12378');
                        this.$api.parkinglot.getParkId(data).then(res => {
						
                            if (res.data.code === 200) {
                                this.setAbParkId(res.data.data.parkId);
                                this.$getAdInfo(res.data.data.parkId)
                            } else {
                                if (this.abParkId) {
                                    this.$getAdInfo(this.abParkId)
                                }
                            }
                        })
					}

                })
			},
            getPlateList () {
				let params = {
					openId:localStorage.getItem('userOpenId')||this.userOpenid,
					appId:10003
				}
                plateList(params).then(res =>{
					console.log(res,'65456456');
					this.plateList = res.data;
					if (this.plateList.length > 0) {
                        this.$nextTick(() => {
                            this.$refs.scroll.refresh()
                        });
					}
				})
			},
            handleUntie (userId,plateNumber) {
                this.$weui.confirm('确定解绑该车牌号？',
					() =>{
                    	let form = {
                    	    userId:userId,
                    	    openId: localStorage.getItem('userOpenId')||this.userOpenid,
                            plateNumber:plateNumber,
							appId:10006
						};
						console.log(form,'form');
                    	relievePlate(form).then(res =>{
                    	    this.getPlateList()
						})
					},
					function(){ console.log('no') }, {
                    title: '解绑'
                });
			},
            handleBindPlate () {
                this.$router.push({path:'bindPlatexcx',query:{comeFrom:'plateInfo'}})
			}
		}
    }
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';

	.cube-scroll{
		position: relative;
		text-align: left;
		white-space: normal;
		max-height: 90%
		overflow hidden
		/*background: #ffffff;*/
		margin-bottom 30px
		.advwrap{
			/*width 100%*/
			/*height 0*/
			/*padding-bottom 40%*/
		}
		.weui-article{
			padding-bottom 5px
			section{
				margin-bottom 0
			}
			p{
				font-size $article-merchant-p
				color $article-p-color
			}
		}
		.weui-cell_access .weui-cell__cash:after{
			width 0
		}
		.weui-cell_access .weui-cell__ft{
			padding-right 0
		}
	}
	.weui-btn-area{
		margin-top 20px
		position fixed
		bottom 0
		left 0
		right 0
		.weui-btn{
			width: 100%;
		}
	}
</style>
